export class RequestError extends Error {
  status: number;

  constructor(response: Response) {
    super("Request error");
    this.name = "RequestError";
    this.status = response.status;
  }
}
